import { CustomTooltipPosition } from './custom-tooltip-positioning.util';

export const CUSTOM_TOOLTIP_DEFAULTS: {
  position: CustomTooltipPosition;
  showDelay: number;
  hideDelay: number;
} = {
  position: 'top',
  showDelay: 200,
  hideDelay: 10,
};

export const CUSTOM_TOOLTIP_LAYOUT = {
  gap: 6,
  padding: 10,
  /** Must match $tooltip-animation-duration in custom-tooltip.directive.scss */
  fadeOutDuration: 200,
} as const;

export const CUSTOM_TOOLTIP_INTERACTION = {
  transitPadding: 2,
  lateralToleranceOffset: 2,
  /** Max pixel drift of the host element before a scroll event dismisses the tooltip. */
  scrollDismissThreshold: 2,
} as const;
